
import React from 'react';
import { Zap, RotateCcw, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { CompressionResult } from '@/types/imageFile';
import { downloadFile } from '@/utils/imageCompression';

interface ActionButtonsProps {
  status: 'pending' | 'processing' | 'completed' | 'failed';
  retryCount: number;
  maxRetryAttempts: number;
  compression?: CompressionResult;
  fileName: string;
  onCompress: () => void;
  onRetry: () => void;
  isPremium?: boolean;
}

const ActionButtons = ({ 
  status, 
  retryCount, 
  maxRetryAttempts, 
  compression,
  fileName, 
  onCompress, 
  onRetry,
  isPremium = false 
}: ActionButtonsProps) => {
  const handleDownloadCompressed = () => {
    if (compression) {
      downloadFile(compression.compressedFile, `compressed_${fileName}`);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      {/* Primera fila: Comprimir */}
      <div className="flex gap-2">
        {status === 'pending' && (
          <Button
            onClick={onCompress}
            size="sm"
            className={`flex-1 ${
              isPremium 
                ? 'bg-purple-600 hover:bg-purple-700' 
                : 'bg-green-600 hover:bg-green-700'
            }`}
          >
            <Zap className="w-4 h-4 mr-1" />
            Comprimir
          </Button>
        )}
      </div>

      {/* Segunda fila: Descargas y otros estados */}
      <div className="flex gap-2">
        {status === 'failed' && retryCount < maxRetryAttempts && (
          <Button
            onClick={onRetry}
            size="sm"
            variant="outline"
            className="flex-1"
          >
            <RotateCcw className="w-4 h-4 mr-1" />
            Reintentar
          </Button>
        )}
        
        {status === 'completed' && compression && (
          <Button
            onClick={handleDownloadCompressed}
            size="sm"
            variant="outline"
            className="flex-1"
          >
            <Download className="w-4 h-4 mr-1" />
            {compression.compressedFile.type === 'image/png' ? 'PNG' : compression.compressedFile.type === 'image/webp' ? 'WebP' : 'JPEG'}
          </Button>
        )}

        {status === 'failed' && retryCount >= maxRetryAttempts && (
          <div className="flex-1 text-center text-xs text-red-500 py-2">
            Máximo de intentos alcanzado
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionButtons;
